import { c as _c } from "react/compiler-runtime";
import MailIcon from '@mui/icons-material/Mail';
import { translate } from '@openclassrooms/translations';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import ContactChannelButton from '../ContactChannelButton';
export default function ButtonExternalFormEmployer() {
  const $ = _c(5);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t0;
  if ($[0] !== getLocalisationConfig) {
    t0 = getLocalisationConfig("contact.employerForm.url");
    $[0] = getLocalisationConfig;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = String(t0);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("support.global.contact_channel.help_center_contact.title");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <ContactChannelButton iconComponent={MailIcon} href={t1} data-event="Navigation|Redirection::External|support-panel|contact-form-employer">{t2}</ContactChannelButton>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}